<template>
  <div>
    <div class="top-bar__tip">
      <div id="tickerbar" >
        <ul >
           <li><strong>Tip:</strong> Downloads and streams are encrypted with HTTPS.</li>
           <li><strong>Tip:</strong> Your storage limit is at the top right.</li>
           <li><strong>Tip:</strong> <a href="/faq" >Problems? Click here to open a ticket</a></li>
           <li><strong>Tip:</strong> Slow speed? Try enabling Cloudflare at the  <strong>Account Information</strong> page.</li>
        </ul>
     </div>
    </div>
    <flash message="" class="mb-4 pl-4"></flash>
    <h2 class="section__title mb-4 pt-4">New Download</h2>
    <form @submit.prevent="startDownload($event)" class="form-download">
      <vue-dropzone ref="myVueDropzone" id="dropzone" @vdropzone-file-added="selectFile" @vdropzone-sending="uploadingFile" @vdropzone-success="uploadSuccess" @vdropzone-error="uploadError"  :options="dropzoneOptions"  :useCustomSlot=true>
        <div class="dropzone-custom-content uploader_dropzone">
          <textarea name="links" v-model="links" id="download" cols="30" rows="10" placeholder="Enter your links or drag/drop your torrent files"></textarea>
          <div class="form-download__files js-downloaded-files" v-show="uploaded_torrent > 0">
            <span class="js-file-count">{{ uploaded_torrent }}</span> uploaded torrent(s)
          </div>
          <div class="form-download__actions my-2 my-md-0">
            <div class="control-checkbox --style-small d-inline-block m-2">
              <label>
                <input type="checkbox" v-model="hdd" @click="saveToHDD"><span class="control-checkbox__checkbox"><i></i></span><span class="control-checkbox__text">Save to HDD Files</span>
              </label>
            </div>
            <div class="btn --theme-secondary --style-xsmall upload-torrent">Upload Torrent</div>
            <button type="submit" class="btn --theme-blue --style-xsmall px-5" id="start_download">Start Download</button>
            
         </div>
        </div>
        <div class="text-center uploader_complete d-none">
             <p class="mt-4"><i class="fas fa-check-circle text-success mr-2"></i>{{uploaded_torrent}} files has been successfully selected</p>
            <span class="sprite-arrow"></span>
        </div>
      </vue-dropzone>
    </form>

    <div class="row  mt-3">
      <div class="col-12 mb-3" >
        <div class="card"  v-show="direct_links.length > 0 && toggle">
          <div class="card-header bg-transparent border-bottom-0 pb-0">
            <button @click='toggle = !toggle' type="button" class="close" aria-label="Close">
              <i class="fas fa-times-circle text-secondary"></i>
            </button>
          </div>
          <div class="card-body px-2 px-md-4 pt-1">
            <div class="d-flex justify-content-between mt-2">
              <div class="align-self-center">
                <h2 class="section__title mb-0">Download Links</h2>
              </div>
              <div class="align-self-center">
                <div class="btn --theme-secondary --style-xsmall " @click="exportAllLinks($event)"><i class="fas fa-file-export fa-fw"></i> Export All</div>
                <div class="btn --theme-secondary --style-xsmall" @click="startDownloadAll($event)"><i class="fas fa-download  fa-fw"></i> Download All</div>
              </div>
            </div>
            <div class="border-top clickable_links pt-2 my-2" v-for="(direct, index) in direct_links">
                <p style="word-break:break-all" class="mb-0"><b>{{  direct.link }}</b>
                  <a :href="direct.location" class="float-right btn btn-outline-secondary"><i class="fas fa-download  fa-fw"></i> Download</a>
                </p>
                <p class="text-muted mb-2">{{  direct.name }} ({{  direct.size | humanFileSize }})</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="card border-0">
          <div class="card-body ">
            <div class="d-flex flex-sm-row flex-column justify-content-between mb-4">
                <h2 class="section__title mb-0">
                   HDD File Downloads
                </h2>
            </div>
            <div v-if="typeof(transfers_recent_hdd.length) === 'undefined'" class="text-center py-3">
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
            <div v-else class="row">
              <div class="col-12 py-2">
                <div class="d-flex flex-sm-row flex-column justify-content-between mb-2">
                    <span class="toggle-section-title" data-toggle="collapse" href="#active_hdd" aria-expanded="true">
                    <i class="arrow fas toggle-section-icon" aria-hidden="true"></i> <b>Active</b> <span v-if="typeof(transfers_active_hdd.length) === 'undefined'">(0)</span><span v-else>({{transfers_active_hdd.length}})</span>
                    </span>
                </div>
              </div>
              <div id="active_hdd" class="collapse show col-12">
                <div class="row">
                  <div class="col-md-12 transfer-list">
                    
                    <div class="d-flex flex-row transfer_list transfer-content" v-for="(transfer, index) in transfers_active_hdd">
                     <!--  <div v-show="transfer.status != 'finished'" class="bg" :style="[transfer.progress*100 > 0 ? { width: transfer.progress*100 + '%', background: 'rgba(147,224,51,.2)'} : { }]"></div> -->
                      <div class="d-flex flex-grow-0 justify-content-center align-self-center transfer-icon">
                        <i class="icon icon-hour-glass" style="font-size: 32px; padding: 4px;"></i>
                      </div>
                      <div class="name px-1 d-flex flex-grow-1 text-white justify-content-start align-self-center">
                        <div class="d-flex flex-column w-100" v-if="transfer.status != 'finished'">
                            <span class="transfer-name">{{ transfer.name }}</span>
                            
                            <small class="text-secondary">{{ transfer.message }}</small>
                            <div class="progress" style="height: 10px;">
                             <div class="progress-bar bg-success" role="progressbar" :style="[transfer.progress*100 > 0 ? { width: transfer.progress*100 + '%'} : { width: 0+'%' }]"   aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                        </div>
                      </div>
                      <div class="action d-flex flex-grow-0 text-white justify-content-center align-self-center">
                        <button class="btn transfer-remove" @click="deleteTransfer($event,index,transfer.id,transfer.status)" v-bind:id="'delete_'+transfer.id"><i class="fas fa-times-circle text-secondary"></i></button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12  py-2">
                <div class="d-flex flex-sm-row flex-column justify-content-between mb-2">
                  <div>
                    <span class="toggle-section-title" data-toggle="collapse" href="#recent_hdd" aria-expanded="true">
                    <i class="arrow fas toggle-section-icon" aria-hidden="true"></i> <b>Recent</b> <span v-if="typeof(transfers_recent_hdd.length) === 'undefined'">(0)</span><span v-else>({{transfers_recent_hdd.length}})</span>
                    </span>
                    <a href="javascript:void(0);" class="px-2 clear-all text-decoration-none" data-toggle="modal" data-target="#deleteHDDFilesModal">
                      <small><i class="fas fa-times-circle"></i> Clear All</small>
                    </a>
                  </div>
                </div>
              </div>
              <div id="recent_hdd" class="collapse show col-12">
                <div class="row">
                  <div class="col-md-12 transfer-list">
                    <table  class="transfer-tbl w-100">
                      <tbody>
                        <tr class="align-items-center transfer-content is-finished" v-for="(transfer, index) in transfers_recent_hdd">
                          <td class="transfer-icon">
                            <span v-if="transfer.status == 'finished'">
                              <i class="icon icon-type-txt"  v-if="transfer.name.includes('.txt')"></i> 
                              <i class="icon icon-type-pdf"  v-else-if="transfer.name.includes('.pdf')"></i> 
                              <i class="icon icon-type-mp3"  v-else-if="transfer.name.includes('.mp3')"></i> 
                              <i class="icon icon-type-flv"  v-else-if="transfer.name.includes('.flv')"></i> 
                              <i class="icon icon-type-rar"  v-else-if="transfer.name.includes('.rar')"></i> 
                              <i class="icon icon-type-mp4"  v-else-if="transfer.name.includes('.mp4')"></i> 
                              <i class="icon icon-mkv"  v-else-if="transfer.name.includes('.mkv')"></i> 
                              <i class="icon icon-type-avi"  v-else-if="transfer.name.includes('.avi')"></i> 
                              <i class="icon icon-type-html"  v-else-if="transfer.name.includes('.html')"></i> 
                              <i class="icon icon-type-exe"  v-else-if="transfer.name.includes('.exe')"></i> 
                              <i class="icon icon-type-iso"  v-else-if="transfer.name.includes('.iso')"></i>
                              <i class="icon icon-type-torrent"  v-else-if="transfer.name.includes('.torrent')"></i>  
                              <i class="icon icon-type-file"  v-else-if="transfer.file_id !== null"></i>
                              <i class="icon icon-folder" style="font-size: 34px;padding: 3px;" v-else></i>
                              </span>
                              <span v-else-if="transfer.status ==  'running'">
                               <i class="icon icon-hour-glass" style="font-size: 32px; padding: 4px;"></i>
                              </span>
                              <span v-else-if="transfer.status ==  'queued'">
                                <i class="icon icon-queue"></i>
                              </span>
                              <span v-else>
                                <i class="icon icon-error"></i>
                              </span>
                          </td>
                          <td class="name">
                              <div class="d-flex flex-column w-100" v-if="transfer.status != 'finished'">
                                  <span class="transfer-name">{{ transfer.name }}</span>
                                  
                                  <small class="text-secondary">{{ transfer.message }}</small>
                              </div>
                               <div class="d-flex flex-column" v-else>
                                  <a v-if="transfer.status === 'finished' && transfer.file_id !== null" v-bind:href="'/hdd?id=' + transfer.file_id"  class="transfer-name">
                                  {{ transfer.name }}
                                  </a>
                                  <a v-else-if="transfer.status === 'finished' && transfer.folder_id !== null"  v-bind:href="'/hdd?folder_id=' + transfer.folder_id" class="transfer-name">
                                    {{ transfer.name }}
                                  </a>
                                  <a v-else href="javascript:void(0);" class="transfer-name">
                                    {{ transfer.name }}
                                  </a>
                              </div>
                          </td>
                          <td class="action">
                            <span v-if="transfer.status == 'finished'">
                              <span class="d-block d-sm-none">
                                <button class="btn btn-link" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true"><i class="fas fa-ellipsis-v text-dark"></i></button>
                                <ul class="dropdown-menu">
                                  <li>
                                    <a @click="zipTransfer($event,index,null,transfer.file_id)"  v-if="transfer.status === 'finished' && transfer.file_id !== null" class="dropdown-item"><i class="fas fa-download  fa-fw"></i> Download</a>
                                    <a @click="zipTransfer($event,index,transfer.folder_id,null)" v-else-if="transfer.status === 'finished' && transfer.folder_id !== null" class="dropdown-item" ><i class="fas fa-download  fa-fw"></i> Download</a>
                                  </li>
                                  <li>
                                    <a v-bind:href="'/hdd?id=' + transfer.file_id" v-if="transfer.status === 'finished' && transfer.file_id !== null" class="dropdown-item"><i class="fas fa-file fa-fw"></i> Open</a>
                                    <a v-bind:href="'/hdd?folder_id=' + transfer.folder_id" v-else-if="transfer.status === 'finished' && transfer.folder_id !== null" class="dropdown-item" ><i class="fas fa-file fa-fw"></i> Open</a>
                                  </li>
                                  <li>
                                    <a href="javascript:void(0);" class="dropdown-item" @click="deleteTransfer($event,index,transfer.id,transfer.status)" v-bind:id="'delete_'+transfer.id"><i class="fas fa-times-circle fa-fw"></i>  Delete</a>
                                  </li>
                                </ul>
                              </span>
                              <span class="d-none d-sm-block">
                                <span v-if="transfer.status === 'finished' && transfer.file_id !== null">
                                  <button @click="zipTransfer($event,index,null,transfer.file_id)"  class="btn btn-outline-secondary mx-1"><i class="fas fa-download  fa-fw"></i> Download</button>
                                  <a  v-bind:href="'/hdd?id=' + transfer.file_id"  class="btn btn-outline-secondary mx-1"><i class="fas fa-file  fa-fw"></i> Open</a>
                                </span>
                                <span v-else-if="transfer.status === 'finished' && transfer.folder_id !== null" >
                                  <button  @click="zipTransfer($event,index,transfer.folder_id,null)"  class="btn btn-outline-secondary mx-1"><i class="fas fa-download  fa-fw"></i> Download</button>
                                  <a v-bind:href="'/hdd?folder_id=' + transfer.folder_id" class="btn btn-outline-secondary mx-1"><i class="fas fa-file  fa-fw"></i> Open</a>
                                </span>
                                <button class="btn transfer-remove" @click="deleteTransfer($event,index,transfer.id,transfer.status)" v-bind:id="'delete_'+transfer.id"><i class="fas fa-times-circle text-secondary"></i></button>
                              </span>
                            </span>
                            <button v-else class="btn transfer-remove" @click="deleteTransfer($event,index,transfer.id,transfer.status)" v-bind:id="'delete_'+transfer.id"><i class="fas fa-times-circle text-secondary"></i></button>
                          </td>
                        </tr>
                      </tbody>
                    </table>                    
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex flex-sm-row flex-column justify-content-between my-4">
                <h2 class="section__title mb-0">
                   Download Links
                </h2>
            </div>
            <div v-if="typeof(stream_downloads.length) === 'undefined'" class="text-center py-3">
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
            <div v-else class="row">
              <div class="col-12">
                <div class="d-flex flex-sm-row flex-column justify-content-between mb-2">
                  <div>
                    <span class="toggle-section-title" data-toggle="collapse" href="#stream_downloads" aria-expanded="true">
                    <i class="arrow fas toggle-section-icon" aria-hidden="true"></i> <b>Recent </b> <span v-if="typeof(stream_downloads.length) === 'undefined'">(0)</span><span v-else>({{stream_downloads.length}})</span>
                    </span>
                    <a  href="javascript:void(0);" class="px-2 clear-all text-decoration-none" data-toggle="modal" data-target="#deleteStreamDownloadsModal">
                      <small><i class="fas fa-times-circle"></i> Clear All</small>
                    </a>
                  </div>
                </div>
              </div>
              <div id="stream_downloads" class="collapse show col-12">
                <div class="row">
                  <div class="col-md-12 transfer-list">
                    
                    <div class="d-flex flex-row transfer_list transfer-content" v-for="(history, index) in stream_downloads">
                      <div class="d-flex flex-grow-0 justify-content-center align-self-center transfer-icon">
                        <i class="icon icon-type-txt"  v-if="history.name.includes('.txt')"></i> 
                        <i class="icon icon-type-pdf"  v-else-if="history.name.includes('.pdf')"></i> 
                        <i class="icon icon-type-mp3"  v-else-if="history.name.includes('.mp3')"></i> 
                        <i class="icon icon-type-flv"  v-else-if="history.name.includes('.flv')"></i> 
                        <i class="icon icon-type-rar"  v-else-if="history.name.includes('.rar')"></i> 
                        <i class="icon icon-type-mp4"  v-else-if="history.name.includes('.mp4')"></i> 
                        <i class="icon icon-mkv"  v-else-if="history.name.includes('.mkv')"></i> 
                        <i class="icon icon-type-avi"  v-else-if="history.name.includes('.avi')"></i> 
                        <i class="icon icon-type-html"  v-else-if="history.name.includes('.html')"></i> 
                        <i class="icon icon-type-exe"  v-else-if="history.name.includes('.exe')"></i> 
                        <i class="icon icon-type-iso"  v-else-if="history.name.includes('.iso')"></i>
                        <i class="icon icon-type-torrent"  v-else-if="history.name.includes('.torrent')"></i>  
                        <i class="icon icon-folder" style="font-size: 34px;padding: 3px;" v-else></i>
                      </div>
                      <div class="name px-1 d-flex flex-grow-1 text-white justify-content-start align-self-center">
                        <div class="d-flex flex-column w-100">
                            <a href="javascript:void(0);" @click="retryTransfer(index,history.src)" class="transfer-name">{{ history.name }}</a>
                            <small class="text-secondary d-none"  v-bind:id="'history_'+index">Link resubmitted to Downloader ...</small>
                        </div>
                      </div>
                      
                      <div class="action d-flex flex-grow-0 text-white justify-content-center align-self-center">
                        <button class="btn btn-outline-secondary mx-1"  @click="retryTransfer(index,history.src)" v-bind:id="'resubmit_btn_'+index" ><i class="fas fa-sync"></i> Resubmit</a></button>
                        <!-- <button class="btn btn-outline-secondary mx-1"  @click="viewSource(history.src)"><i class="fas fa-magnet"></i> Source</a></button> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-loader d-none">
        <i class="icon icon-bolt w-loader__small"></i>
        <i class="icon icon-bolt w-loader__big"></i>
    </div>
    <div class="modal fade" id="sourceModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
       <div class="modal-dialog" role="document">
          <div class="modal-content">
             <div class="modal-header">Source</div>
             <div class="modal-body text-center">
                <div class="row pmcard-row">
                   <div class="col-md-12"><textarea rows="5" class="directlinks form-control" id="source" style="white-space: pre;">{{ src }}</textarea></div>
                </div>
             </div>
             <div class="modal-footer">
              <button type="button" class="btn btn-secondary --style-xsmall" data-dismiss="modal">Close</button>
              <button type="button" class="btn btn-primary --style-xsmall" data-dismiss="modal" @click="copyToClipboard(selected_item.src)">Copy Links</button>
             </div>
          </div>
       </div>
    </div>
    <div class="modal fade" id="zipModal" tabindex="-1" role="dialog" aria-labelledby="zipModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="createFolderModalLabel">Zip Download</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="col-md-12 p-2 text-center" v-if="!zip_data.finish">
                <div class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
              <div v-else class="text-center">
                  <div class="alert alert-danger" role="alert" v-if="zip_data.error != null">
                    {{zip_data.error}}
                  </div>
                  <div v-else>
                      <p><a :href="zip_data.link" class="btn btn-success --style-xsmall">Click here to download</a></p>
                  </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary --style-xsmall" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
    </div>
    <div class="modal fade" id="deleteHDDFilesModal" tabindex="-1" role="dialog" aria-labelledby="zipModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="createFolderModalLabel">Clear HDD File Downloads</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <p class="text-break-all">This will delete your Recent HDD File Downloads. Do you want to clear all?</p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn --theme-primary --style-xsmall" @click="deleteHDDFiles">Clear All</button>
              <button type="button" class="btn btn-secondary --style-xsmall" data-dismiss="modal">Cancel</button>
            </div>
          </div>
        </div>
    </div>
    <div class="modal fade" id="deleteStreamDownloadsModal" tabindex="-1" role="dialog" aria-labelledby="zipModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="createFolderModalLabel">Clear Download Links</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <p class="text-break-all">This will delete your Recent Download Links. This history does not count toward traffic limits. Do you want to clear all?</p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn --theme-primary --style-xsmall" @click="deleteStreamDownload">Clear All</button>
              <button type="button" class="btn btn-secondary --style-xsmall" data-dismiss="modal">Cancel</button>
            </div>
          </div>
        </div>
    </div>
    <div class="modal fade" id="exportLinksModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
       <div class="modal-dialog" role="document">
          <div class="modal-content">
             <div class="modal-header">Export Links</div>
             <div class="modal-body text-center">
                <div class="row pmcard-row">
                  <div class="col-md-12" v-if="export_links.length == 0">No links to be export!</div>
                  <div class="col-md-12" v-else>
                    <textarea rows="5" :value="export_links.join('\n')" class="directlinks form-control" style="white-space: pre;"></textarea>
                  </div>
                </div>
             </div>
             <div class="modal-footer">
              <button type="button" class="btn btn-secondary --style-xsmall" data-dismiss="modal">Close</button>
             </div>
          </div>
       </div>
    </div>
  </div>
</template>
 
<script>

    import vue2Dropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'

    export default {
        components: {
          vueDropzone: vue2Dropzone

        },
        props: ['message','folders','premium'],
        data() {
            return {
                is_premium: this.premium,
                dropzoneOptions: {
                    url: '/api/transfers/create',
                    autoDiscover: false,
                    uploadMultiple: true,
                    parallelUploads: 3,
                    maxFiles: 3,
                    autoProcessQueue : false,
                    paramName: "files",
                    acceptedFiles: 'application/x-bittorrent, .torrent',
                    previewsContainer: false,
                    params: () => ({
                      links: [this.filterLinks(this.links)],
                      hdd: this.hdd
                    }),
                    clickable: '.upload-torrent',
                    "error": function(file, message, xhr) {
                       if (xhr == null) this.removeFile(file); // perhaps not remove on xhr errors
                    },
                    headers: {
                      "X-CSRF-TOKEN": document.head.querySelector("[name=csrf-token]").content
                     }
                },
                transfers_recent_hdd: {},
                transfers_active_hdd: {},
                stream_downloads: {},
                processNZBBtn: true,
                links: [],
                hdd: false,
                uploaded_torrent: 0,
                uploaded_files: {},
                counter: 0,
                passwords : [],
                src: null,
                zip_data: { link: null, finish: false, error: null },
                white_listed_domains: [],
                direct_links: [],
                export_links: [],
                toggle: true
            }
        },
        created() {
          this.whiteListedHosts();
          this.list();
          this.updateList();
          this.historyList();
          this.submitFromQueryVariable();

          if(localStorage.getItem('save_to_hdd')){
            this.hdd = localStorage.getItem('save_to_hdd') === "true";
          }
        },
        filters: {
          humanFileSize: (bytes) => {
              var thresh = 1024;
              if(Math.abs(bytes) < thresh) {
                  return bytes + ' B';
              }
              var units = ['KB','MB','GB','TB','PB','EB','ZB','YB'];
              var u = -1;
              do {
                  bytes /= thresh;
                  ++u;
              } while(Math.abs(bytes) >= thresh && u < units.length - 1);
              return bytes.toFixed(1)+' '+units[u];
          },

        },
        methods: {
            async list(){
              axios.get('/api/transfers/list').then( response=> {
                    this.transfers_recent_hdd =response.data.transfers_list.recent_hdd;
                    this.transfers_active_hdd = response.data.transfers_list.active_hdd;

                    var clear = true;
                    for(var i = 0; i < this.transfers_active_hdd.length; i++) {
                     
                      if(this.transfers_active_hdd[i].status == 'running' || this.transfers_active_hdd[i].status == 'queued') {

                          clear = false; 
                          break;
                      }
                    }
                    
                    if(clear) {
                        clearInterval(this.interval);
                    }

                }).catch(error=>{
                    flash(JSON.parse(error.request.response).message, 'error');
                })
            },
            updateList(){
              clearInterval(this.interval);
              this.interval = setInterval(this.list, 5000);
            },
            historyList(){
              axios.get('/api/history/list').then( response=> {
                    this.stream_downloads = response.data.history_list;
                }).catch(error=>{
                    flash(JSON.parse(error.request.response).message, 'error');
                })
            },
            getQueryVariable(variable) {
              var query = window.location.search.substring(1);
              var vars = query.split('&');
              for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split('=');
                if (decodeURIComponent(pair[0]) == variable) {
                  return decodeURIComponent(pair[1]);
                }
              }
              return false;
            },
            submitFromQueryVariable() {
              if (this.getQueryVariable('magnet')) {
                var magnet = this.getQueryVariable('magnet');
                this.links = magnet;
                this.startDownload();
              }
            },
            filterLinks(){

              if(this.links.length > 0) {
                var links = this.links.split('\n');
                var filtered_lines = links.filter(function (el) {
                  return el != '' ;
                });
                return filtered_lines;
              } else {
                return [];
              }

            },
            clearFinished(e) {
                $("button#clear_hdd_btn").attr("disabled", true);
                $("button#clear_hdd_btn").html('<i class="fas fa-spinner fa-pulse  text-secondary"></i>');
                axios.delete('api/transfers/clearfinished').then(response=>{
                    $("button#clear_hdd_btn").html('<i class="fas fa-times-circle"></i> Clear HDD Activity').attr("disabled", false);;
                    if(response.data.status == 'success'){
                      this.updateList();
                      flash(response.data.message, 'success');
                    } else {
                       flash('Error on clearing hdd activity', 'error');
                    }
                }).catch(error=>{
                    $("button#clear_hdd_btn").html('<i class="fas fa-times-circle"></i> Clear HDD Activity').attr("disabled", false);;
                    flash(JSON.parse(error.request.response).message, 'error');
                });
                
            },
            deleteHDDFiles(){
              axios.delete('/api/transfers/clearfinished').then( response=> {
                  $('#deleteHDDFilesModal').modal('toggle');
                  this.updateList();
                  flash(response.data.message, 'success');
              }).catch(error=>{
                    flash(JSON.parse(error.request.response).message, 'error');
              })
            },
            deleteStreamDownload(){
              axios.post('/api/history/clear').then( response=> {
                  $('#deleteStreamDownloadsModal').modal('toggle');
                  this.updateList();
                  flash(response.data.message, 'success');
              }).catch(error=>{
                    flash(JSON.parse(error.request.response).message, 'error');
              })
            },
            selectFile(){
              this.processNZBBtn = false;
              // $('.uploader_dropzone').addClass('d-none');
              // $('.uploader_complete').removeClass('d-none');
              //console.log(this.$refs.myVueDropzone.dropzone.files,this.$refs.myVueDropzone.dropzone.files.length);
              this.uploaded_torrent = this.$refs.myVueDropzone.dropzone.files.length;
              this.uploaded_files = this.$refs.myVueDropzone.dropzone.files;
            },
            uploadingFile(file, xhr, formData){
              if(typeof(this.passwords[this.counter]) !== 'undefined'){
                formData.append('password['+this.counter+']', this.passwords[this.counter]);
                this.counter = this.counter + 1;
              }
            },
            whiteListedHosts() {

               axios.post('/api/services/list').then( response=> {
                  if(response.data.status == 'error') {
                    return false;
                  }
                  var domains = [];
                  response.data.services.directdl.forEach((value, index) => {
                    Object.keys(response.data.services.aliases[value]).forEach(function (key2) {
                      domains.push(response.data.services.aliases[value][key2])
                    });
                  });

                  this.white_listed_domains = domains;
                  //console.log(this.white_listed_domains);

              }).catch(error=>{
                 console.log(error);
              });
            },
            transferEndPoint(src) {
              var matches = src.match("^(?:https?:)?(?:\/\/)?(?:www.?)?([^\/\?]+)");
              var domain = matches && matches[1];
              for(var i=0;i<this.white_listed_domains.length; i++){
                if(domain.endsWith(this.white_listed_domains[i]))
                  return "directdl";
              }
              return "create";
            },
            startDownload(e) {

              

              if(this.uploaded_torrent > 0){

                $('#start_download').prop('disabled', true);
                $('.w-loader').removeClass('d-none');

                this.$refs.myVueDropzone.processQueue();

              } else {

                if(this.links.length > 0){

                  $('#start_download').prop('disabled', true);
                  $('.w-loader').removeClass('d-none');

                  if(this.hdd == true){

                    axios.post('/api/transfers/create',{links : this.filterLinks(this.links), hdd: this.hdd}).then(response=>{

                      this.links = '';
                      $('#start_download').prop('disabled', false);
                      $('.w-loader').addClass('d-none');
                      
                      if(response.data.status == 'success'){
                        this.updateList();
                        flash(response.data.message, 'success');
                      } 
                     
                    }).catch(error=>{
                        flash(JSON.parse(error.request.response).message, 'error');
                        $('#start_download').prop('disabled', false);
                        $('.w-loader').addClass('d-none');
                    });

                  } else {

                    let promises = [];
                    var filtered_links = this.filterLinks(this.links);
                    for(var i=0;i<filtered_links.length; i++){

                      var api_endpoint = this.transferEndPoint(filtered_links[i]);
                     
                        if(api_endpoint == 'directdl'){
                          
                          promises.push(
                            axios.post('/api/transfers/directdl', {link : filtered_links[i]}).then(response=>{
                            
                              if(response.data.status == 'success'){

                                if(response.data.type == 'container'){

                                    var links = response.data.content;

                                    for(var i=0;i<links.length; i++){

                                        axios.post('/api/transfers/directdl', {link : links[i]}).then(response=>{

                                          this.direct_links.push({"link" : response.data.link, 'name' : response.data.name, 'size' : response.data.size, 'location' : response.data.location });
                                          this.toggle = true;

                                          return response;

                                        }).catch(error=>{
                                           return error;
                                        })
                                    }

                                } else {
                                  this.direct_links.push({"link" : response.data.link, 'name' : response.data.name, 'size' : response.data.size, 'location' : response.data.location });
                                  this.toggle = true;
                                }
                              } 

                              return response;
                             
                            }).catch(error=>{
                               return error;
                            })
                          );

                        } else {

                          promises.push(
                            axios.post('/api/transfers/create', {links : [filtered_links[i]]}).then(response=>{
                              
                              if(response.data.status == 'success'){
                                this.updateList();
                                flash(response.data.message, 'success');
                              } 

                              return response;
                             
                            }).catch(error=>{
                               return error;
                            })
                          );

                        }
                    }

                    
                    Promise.all(promises).then(response => {

                      $('#start_download').prop('disabled', false);
                      $('.w-loader').addClass('d-none');

                      this.links = '';
                      this.updateList();

                      for(var i=0;i<response.length; i++){
                        if(JSON.parse(response[i].request.response).status == 'error'){
                          flash(JSON.parse(response[i].request.response).message, 'error');
                        }
                      }
                      
                    });
                  }
                }
              }
            },
            uploadSuccess(file, response) {
            
              this.$refs.myVueDropzone.removeAllFiles();
              this.uploaded_torrent = 0;
              this.uploaded_files = {};
              $('#start_download').prop('disabled', false);
              $('.w-loader').addClass('d-none');
              this.updateList();
              flash(response.message, 'success');
            },
            uploadError(file, response) {
              this.$refs.myVueDropzone.removeAllFiles();
              this.uploaded_torrent = 0;
              this.uploaded_files = {};
              $('#start_download').prop('disabled', false);
              $('.w-loader').addClass('d-none');
              flash(response.message, 'error');
            },
            retryTransfer: function(index,src){

              $("button#resubmit_btn_"+index).attr("disabled", true);
              $("button#resubmit_btn_"+index).html('<i class="fas fa-spinner fa-pulse"></i>');

              var api_endpoint = this.transferEndPoint(src);
              if(api_endpoint == 'directdl'){
                $('#history_'+index).removeClass('d-none');
                axios.post('/api/transfers/directdl',{link : src}).then(response=>{
                  if(response.data.status == 'success'){
                      this.direct_links.push({"link" : response.data.link, 'name' : response.data.name, 'size' : response.data.size, 'location' : response.data.location });
                      this.toggle = true;
                      $('#history_'+index).addClass('d-none');
                      $("button#resubmit_btn_"+index).attr("disabled", false);
                      $("button#resubmit_btn_"+index).html('<i class="fas fa-sync"></i> Resubmit');
                  } 
                }).catch(error=>{
                  flash(JSON.parse(error.request.response).message, 'error');
                  this.toggle = true;
                  $('#history_'+index).addClass('d-none');
                  $("button#resubmit_btn_"+index).attr("disabled", false);
                  $("button#resubmit_btn_"+index).html('<i class="fas fa-sync"></i> Resubmit');
                });
              } else {
                axios.post('/api/transfers/create',{links : [src]}).then(response=>{
                  if(response.data.status == 'success'){
                      this.updateList();
                      flash(response.data.message, 'success');
                      $("button#resubmit_btn_"+index).attr("disabled", false);
                      $("button#resubmit_btn_"+index).html('<i class="fas fa-sync"></i> Resubmit');
                  } 
                }).catch(error=>{
                   console.log(error);
                  $("button#resubmit_btn_"+index).attr("disabled", false);
                  $("button#resubmit_btn_"+index).html('<i class="fas fa-sync"></i> Resubmit');
                });
              }
            },
            zipTransfer(e,index,folder_id,file_id) {
                this.zip_data =  { link: null, finish: false, error: null };
                $('#zipModal').modal('toggle');

                var foldersItems = []; 
                var filesItems = [];

                if(folder_id != null){
                  foldersItems.push(folder_id);

                  axios.post('/api/zip/generate',{'folder_ids': foldersItems}).then(response=>{
                      e.target.disabled = false;
                      if(response.data.status == 'success'){
                        this.zip_data = { link: response.data.location, finish: true, error: null };
                      } 

                  }).catch(error=>{
                      this.zip_data = { link: null, finish: true, error:  JSON.parse(error.request.response).message };
                  });

                } else if(file_id != null){
                  filesItems.push(file_id);

                  axios.post('/api/zip/generate',{'file_ids': filesItems}).then(response=>{
                      e.target.disabled = false;
                      if(response.data.status == 'success'){
                        this.zip_data = { link: response.data.location, finish: true, error: null };
                      } 

                  }).catch(error=>{
                      this.zip_data = { link: null, finish: true, error:  JSON.parse(error.request.response).message };
                  });
                }

                

            },
            downloadTransfer(e,index,file_id) {
                axios.post('/api/item/details',{file_id : file_id}).then(response=>{
                    if(response.data.status == 'success'){
                       window.location.href = response.data.details.link;
                    }
                }).catch(error=>{
                    console.log(error);
                });
            },
            viewSource(src) {
              this.src = src;
              $('#sourceModal').modal('toggle');
            },
            deleteTransfer(e,index,id) {
                if(confirm("Are you sure, you want to delete this download?")){
                    $("#delete_"+id).attr("disabled", true);
                    $('#delete_'+id).html('<i class="fas fa-spinner fa-pulse  text-secondary"></i>');
                    axios.delete('api/transfers/delete/'+id).then(response=>{
                      flash(response.data.message, 'success');
                      this.list();
                      $('#delete_'+id).html('<i class="fas fa-times-circle text-secondary"></i>').attr("disabled", false);
                    }).catch(error=>{
                        $('#delete_'+id).html('<i class="fas fa-times-circle text-secondary"></i>').attr("disabled", false);
                        flash('Error on deleting torrent', 'error');
                    });
                } 
            },
            exportAllLinks(e){
              this.export_links = [];
              for(var i = 0; i < this.direct_links.length; i++) {
                  this.export_links.push(this.direct_links[i].location);
              }

              $('#exportLinksModal').modal('toggle');
            },
            startDownloadAll(e){
              for(var i = 0; i < this.direct_links.length; i++) {
                this.downloadURL(this.direct_links[i].location);
              }
            },
            downloadURL(url){
              var iframe = document.createElement('iframe');
              iframe.style.display = 'none';
              document.body.appendChild(iframe);
              iframe.src = url;
            },
            copyToClipboard: function(text) {
              if (window.clipboardData && window.clipboardData.setData) {
                // IE specific code path to prevent textarea being shown while dialog is visible.
                return clipboardData.setData("Text", text);

              } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
                var textarea = document.createElement('textarea');
                textarea.textContent = text;
                document.body.appendChild(textarea);
                var selection = document.getSelection();
                var range = document.createRange();
                range.selectNode(textarea);
                selection.removeAllRanges();
                selection.addRange(range);
                try {
                  return document.execCommand("copy"); // Security exception may be thrown by some browsers.
                } catch (ex) {
                  console.warn("Copy to clipboard failed.", ex);
                  return false;
                } finally {
                  selection.removeAllRanges();
                  document.body.removeChild(textarea);
                }
              }
            },
            saveToHDD(){
              this.hdd = !this.hdd;
              localStorage.setItem('save_to_hdd', this.hdd);
            }
        }
    }
</script>